import { z } from 'zod';
import { civilDate } from './common.js';
import { buildingSchema, planetSchema, regionTreeSchema, taskSchema } from './world.js';
/**
 * A day of the universe, read-only.
 *
 * The same things the live app draws from, for every planet at once: the
 * globe's geometry comes from the tree and the world art, both deterministic,
 * so a day looks exactly as it looked with nothing stored about the picture
 * itself.
 */
export const snapshotPlanetSchema = z.object({
    planet: planetSchema,
    tree: regionTreeSchema,
    buildings: z.array(buildingSchema),
    /** What had been finished by that day: the boats on its ocean. */
    doneTasks: z.array(taskSchema),
});
export const worldSnapshotSchema = z.object({
    day: civilDate,
    /**
     * Worked out backwards from timestamps rather than written on the day. The
     * work, the prayers and the health that follows from them are exact; names,
     * weights and marks are today's, carried back.
     */
    reconstructed: z.boolean(),
    planets: z.array(snapshotPlanetSchema),
});
export const snapshotDaysSchema = z.object({
    days: z.array(z.object({ day: civilDate, reconstructed: z.boolean() })),
});
//# sourceMappingURL=snapshot.js.map